import { StyleSheet } from "react-native";

export const styles = StyleSheet.create({
  container: {
    width: 350,
    marginBottom: 12,
    alignSelf: "center",
    alignItems: "center",
    padding: 12,
    marginTop: 60,
    padding: 16,
    borderRadius: 8,
    borderColor: "#FFF",
    borderWidth: 0.5,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4.84,
    elevation: 4,
  },
  holderTitle: {
    marginTop: 8,
    paddingVertical: 8,
    borderBottomWidth: 1,
    borderBottomColor: "#ccc",
  },
  contentBtn: {
    marginVertical: 25,
  },

  button: {
    paddingVertical: 10,
    minWidth: 320,
    minHeight: 60,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    marginTop: "3%",
    backgroundColor: "#077A97",
    borderColor: "#077A97",
    borderWidth: 0,
  },

  mainHeaderTxt: {
    color: "#077A97",
    marginBottom: 20,
    marginTop: 12,
    fontSize: 30,
    fontWeight: "600",
  },
});
